import script from "./InvoiceableModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./InvoiceableModal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__